import { createSlice } from '@reduxjs/toolkit'
import PlayerInterface from '../../interfaces/Player.interface'

const initialState: PlayerInterface = {

}

export const playerSlice = createSlice({
    name: 'player',
    initialState,
    reducers: {
        setPlayer: (_, { payload }) => payload,
        addTeam: (state, { payload }) => {
            state.teams?.push(payload)
        },
        deleteTeam: (state, { payload }) => {
            state.teams = state?.teams?.filter(team => team.id !== payload)
        },
        setContracts: (state, { payload }) => {
            state.contracts = payload
        },
        changeContractStatus: (state, { payload }) => {
            const contract = state.contracts?.find(contract => payload.contractId === contract.id)

            if (contract) {
                contract.status = payload.status
            }
        },
        resetPlayer: () => initialState
    }
})
export const { setPlayer, resetPlayer, addTeam, setContracts, changeContractStatus, deleteTeam } = playerSlice.actions
export default playerSlice.reducer